import { useEffect, useState } from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_leo-carter-impact/artifacts/7nvj4c0n_LEO%20CLUB%20OF%20MUMBAI%20CARTER%20ROAD%20%281%29.png";

export default function SplashScreen() {
  // Only show splash on the home page (every refresh of /), never on other routes.
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.location.pathname === "/";
  });
  const [exiting, setExiting] = useState(false);
  const [fastExit, setFastExit] = useState(false);

  useEffect(() => {
    if (!show) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const t1 = setTimeout(() => setExiting(true), 6500);
    const t2 = setTimeout(() => {
      setShow(false);
      document.body.style.overflow = prevOverflow;
    }, 7500);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      document.body.style.overflow = prevOverflow;
    };
  }, [show]);

  if (!show) return null;

  const dismiss = () => {
    if (fastExit || exiting) return;
    setFastExit(true);
    setTimeout(() => {
      setShow(false);
      document.body.style.overflow = "";
    }, 300);
  };

  return (
    <div
      onClick={dismiss}
      role="button"
      aria-label="Dismiss splash"
      className="fixed inset-0 bg-black flex flex-col items-center justify-center cursor-pointer"
      style={{
        zIndex: 9999,
        opacity: fastExit || exiting ? 0 : 1,
        transition: `opacity ${fastExit ? "300ms" : "1000ms"} cubic-bezier(0.25, 1, 0.5, 1)`,
      }}
      data-testid="splash-screen"
    >
      <img
        src={LOGO_URL}
        alt="Leo Club of Mumbai Carter Road"
        className="splash-logo w-[160px] md:w-[220px] h-auto select-none pointer-events-none"
        draggable="false"
      />
      <div className="mt-10 md:mt-12 text-center px-6">
        <p
          className="splash-line-1 font-inter font-light text-white text-base md:text-xl"
          style={{ letterSpacing: "0.15em" }}
        >
          Every generation has its moment.
        </p>
        <p className="splash-line-2 font-playfair italic mt-3 md:mt-4 text-xl md:text-3xl" style={{ color: "#8B1E2D" }}>
          This is yours.
        </p>
      </div>
    </div>
  );
}
